module.exports = __webpack_public_path__ + "5d306f6850cb8aeb471997eefadc8a5d.pdf";